import React from 'react';

import { useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';

import FieldSelect from '../commons/FieldSelect';
import FieldText from '../commons/FieldText';

const AdditionalData = ({ isInsuredPerson }) => {
  const activities = useSelector((state) => state.catalogs.activities);
  const nationalities = useSelector((state) => state.catalogs.nationalities);

  return (
    <div>
      <h3>Adicionales</h3>
      <hr className="solid" />
      <div className="field-row">
        <FieldSelect
          label="Actividad"
          required
          keyLabel="name"
          keyName="id"
          list={activities}
          name="activity" />
        <FieldText
          label="Fuente de ingresos"
          name="sourceIncome"
          required />
      </div>
      <div className="field-row">
        <FieldSelect
          label="Nacionalidad"
          keyLabel="name"
          keyName="id"
          required
          list={nationalities}
          name="nationality" />
        {isInsuredPerson && (
          <FieldSelect
            label="¿Conductor > 30 años?"
            required={false}
            keyLabel="label"
            keyValue="value"
            list={[{ label: 'Si', value: true }, { label: 'No', value: false }]}
            name="isOlderThan30" />
        )}
      </div>
    </div>
  );
};

AdditionalData.propTypes = {
  isInsuredPerson: PropTypes.bool.isRequired,
};

export default AdditionalData;
